import React from 'react';
import { Upload, Cpu, Download } from 'lucide-react';
import { howItWorks } from '../data/mock';

const iconMap = {
  '01': Upload,
  '02': Cpu,
  '03': Download,
};

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 md:py-28 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-4">{howItWorks.title}</h2>
          <p className="body-large max-w-2xl mx-auto" style={{ color: 'var(--text-secondary)' }}>
            {howItWorks.subtitle}
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 md:gap-6">
          {howItWorks.steps.map((step, index) => {
            const Icon = iconMap[step.number];
            return (
              <div key={step.number} className="relative">
                {/* Connector Line */}
                {index < howItWorks.steps.length - 1 && (
                  <div className="hidden md:block absolute top-12 left-1/2 w-full h-0.5 bg-gradient-to-r from-green-300 to-green-100"></div>
                )}
                
                <div className="relative bg-white rounded-2xl p-8 border border-black/5 shadow-sm hover:shadow-md transition-shadow">
                  {/* Step Number */}
                  <div 
                    className="w-24 h-24 rounded-2xl flex items-center justify-center mb-6 mx-auto"
                    style={{ background: 'var(--accent-wash)' }}
                  >
                    <Icon size={40} style={{ color: 'var(--accent-text)' }} />
                  </div>
                  
                  {/* Number Badge */}
                  <div 
                    className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold text-white"
                    style={{ background: 'var(--gradient-button)' }}
                  >
                    {step.number}
                  </div>

                  <h3 className="heading-3 text-center mb-3">{step.title}</h3>
                  <p className="body-small text-center" style={{ color: 'var(--text-secondary)' }}>
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
